import React, { useState } from "react";
import CustomDialog from "../../../components/layouts/common/CustomDialog";
import { closeModal } from "../../../store/actions/modalAction";
import { useDispatch } from "react-redux";
import { callApiAction } from "../../../store/actions/commonAction";
import OrderShipUI from "./OrderShipUI";
import { updateOrderApi } from "../../../apis/patient.api";
import { callSnackBar } from "../../../store/actions/snackbarAction";

const OrderShipController = ({ params, status, callBack}) => {
  const [loading, setLoading] = useState(false);
  const [loadingVerified, setLoadingVerified] = useState(false);
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const [fields, setFields] = useState({
    box_id: "",
    tracking_id: "",
    tracking_link: "",
    courier_name: "",
    status,
    shipping_date: new Date(),
    err: "",
  });

  const onSubmit = (e) => {
    e.preventDefault();
    if (fields.box_id.length < 1) {
      setFields({ ...fields, err: "Box ID is required" });
      return;
    }
    setLoading(true);
    dispatch(
      callApiAction(
        async () =>
          await updateOrderApi({
            id: params.order_ID,
            ...fields,
          }),
        (response) => {
          callBack();
          dispatch(closeModal("orderShip"));
          dispatch(callSnackBar("Order Shipped Successfully", "success"));
          setLoading(false);    
        },
        (err) => {
          console.log("currenygd g error", err);
          setLoading(false);
          setFields({ ...fields, err });
        }
      )
    );
  };

  return (
    <CustomDialog
      id={"orderShip"}
      loading={loading}
      onSubmit={
        !(error.length > 0 || loadingVerified)
          ? onSubmit
          : (e) => {
              e.preventDefault();
            }
      }
      title={"Order Ship"}
      closeText="Close"
      confirmText={"Submit"}
    >
      <OrderShipUI
        error={error}
        setError={setError}
        params={params}
        fields={fields}
        setFields={setFields}
        setLoadingVerified={setLoadingVerified}
        loading={loading}
        setLoading={setLoading}
      />
    </CustomDialog>
  );
};

export default OrderShipController;
